import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { CompleteCourseCommandPayload, CompleteCourseCommand } from '../api';
import { XApiClient } from '@/app/tracking/xapi/tincan/client';
import { createCoursePassedFailedStatement } from './course-passed-failed-statement';

@injectable()
export class XApiCompleteCourseCommandHandler implements CommandHandler<CompleteCourseCommand> {

  constructor(
    @inject(XApiClient)
    private client: XApiClient) {
  }

  public async execute(command: CompleteCourseCommandPayload) {

    const params = {
      id: ''
    };

    if (command.successStatus === 'passed' || command.successStatus === 'failed') {
      const statement = createCoursePassedFailedStatement(params, command.successStatus);
      await this.client.sendStatement(statement);
    }
  }
}
